import type { DiscountType } from "@/features/cart/types/discount.type";

export const getDiscountDetails = ({
  price,
  totalPrice,
  discountCodes,
  numberOfDays,
}: {
  discountCodes?: DiscountType[];
  price?: number;
  totalPrice?: number;
  numberOfDays?: number;
}) => {
  if (!discountCodes || discountCodes.length === 0) {
    return {
      priceAfterDiscount: undefined,
      hasDiscount: false,
    };
  }

  // New logic: if totalPrice and numberOfDays are provided
  if (totalPrice && numberOfDays) {
    // Sum all discount amounts from discount codes
    const totalDiscountAmount = discountCodes.reduce(
      (sum, code) => sum + (code.amount?.gross || 0),
      0
    );

    // Calculate price after discount per day
    const priceAfterDiscount =
      (totalPrice - totalDiscountAmount) / numberOfDays;

    return {
      priceAfterDiscount,
      hasDiscount: true,
    };
  }

  // Old logic: fallback for backward compatibility
  if (!price) {
    return {
      priceAfterDiscount: undefined,
      hasDiscount: false,
    };
  }

  const biggestDiscount = discountCodes.reduce((prev, current) =>
    prev.amount > current.amount ? prev : current
  );

  let priceAfterDiscount = price;

  if (biggestDiscount) {
    if (biggestDiscount.unit === "percentage") {
      priceAfterDiscount =
        price - price * ((biggestDiscount.percentage || 0) / 100);
    } else if (biggestDiscount.unit === "fixed" && numberOfDays) {
      priceAfterDiscount = price - biggestDiscount.amount.gross / numberOfDays;
    } else {
      priceAfterDiscount = price - biggestDiscount.amount.gross;
    }
  }

  return {
    priceAfterDiscount,
    hasDiscount: true,
  };
};
